// extracted by mini-css-extract-plugin
export default {"container":"Thumbnails_container__KMnpE","wrapper":"Thumbnails_wrapper__xyr0k","image":"Thumbnails_image__BobYq","active":"Thumbnails_active__NM73X"};